"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateMetricParams = generateMetricParams;
exports.generateXAxisData = generateXAxisData;
exports.formatDate = formatDate;
exports.normalMetricValue = normalMetricValue;

require("core-js/modules/es.parse-int.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.date.to-string.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

var _date = _interopRequireDefault(require("./date"));

var ONEMINUTE_TIMESTAMP = 60 * 1000;
var ONEHOUR_TIMESTAMP = 60 * ONEMINUTE_TIMESTAMP;
var ONEDAY_TIMESTAMP = 24 * ONEHOUR_TIMESTAMP;
var ONEWEEK_TIMESTAMP = 7 * ONEDAY_TIMESTAMP;
var ONEMONTH_TIMESTAMP = 30 * ONEDAY_TIMESTAMP;
var THREEMONTH_TIMESTAMP = 3 * ONEMONTH_TIMESTAMP;
var HALFYEAR_TIMESTAMP = 6 * ONEMONTH_TIMESTAMP;
var ONEYEAR_TIMESTAMP = 365 * ONEDAY_TIMESTAMP;
var CYCLE_ARR = ['ONEHOUR', 'ONEDAY', 'ONEWEEK', 'ONEMONTH', 'THREEMONTH', 'HALFYEAR', 'ONEYEAR', 'SELFDEFINE'];
var CYCLE_TIMESTAMP_MAP = {
  ONEHOUR: ONEHOUR_TIMESTAMP,
  ONEDAY: ONEDAY_TIMESTAMP,
  ONEWEEK: ONEWEEK_TIMESTAMP,
  ONEMONTH: ONEMONTH_TIMESTAMP,
  THREEMONTH: THREEMONTH_TIMESTAMP,
  HALFYEAR: HALFYEAR_TIMESTAMP,
  ONEYEAR: ONEYEAR_TIMESTAMP
};

function computeStep(startTime, endTime) {
  var gap = (endTime - startTime) * 1000;
  var step = 60; // 1分钟

  if (gap > ONEHOUR_TIMESTAMP && gap <= ONEDAY_TIMESTAMP) {
    step = 300; // 5分钟
  } else if (gap > ONEDAY_TIMESTAMP && gap <= 7 * ONEDAY_TIMESTAMP) {
    step = 900; // 15分钟
  } else if (gap > 7 * ONEDAY_TIMESTAMP && gap <= ONEMONTH_TIMESTAMP) {
    step = 3600; // 1小时
  } else if (gap > ONEMONTH_TIMESTAMP && gap <= ONEYEAR_TIMESTAMP) {
    step = 43200; // 12小时
  } else if (gap > ONEYEAR_TIMESTAMP) {
    step = 86400; // 24小时
  }

  return step;
}

function ms2second(ms) {
  return parseInt(ms / 1000);
}

function generateMetricParams(cycle, startTime, endTime) {
  if (!(cycle && CYCLE_ARR.includes(cycle))) {
    return {
      time_query_type: cycle
    };
  }

  if (cycle === 'SELFDEFINE') {
    return {
      time_query_type: cycle,
      start_time: startTime,
      end_time: endTime,
      step: "".concat(computeStep(startTime, endTime), "s")
    };
  }

  var timestamp = new Date().getTime();
  startTime = ms2second(timestamp - CYCLE_TIMESTAMP_MAP[cycle]);
  endTime = ms2second(timestamp);
  return {
    time_query_type: 'SELFDEFINE',
    start_time: startTime,
    end_time: endTime,
    step: "".concat(computeStep(startTime, endTime), "s")
  };
}

function generateXAxisData(startTime, endTime) {
  var xAxis = [];

  if (!(startTime && endTime && endTime - startTime > 0)) {
    return xAxis;
  }

  var step = computeStep(startTime, endTime);
  var current = startTime;

  do {
    xAxis.push(current);
    current += step;
  } while (current <= endTime);

  return xAxis;
}

function formatDate(second) {
  var flag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd HH:mm:ss';

  if (!(second && flag)) {
    return '';
  }

  return _date["default"].format(new Date(second * 1000), flag);
}

function normalMetricValue(values) {
  if (!(values && values.length)) {
    return {};
  }

  var objValue = {};
  values.forEach(function (item) {
    objValue[item[0]] = item[1];
  });
  return objValue;
}